import { Routes, Route } from 'react-router-dom';
import ForgotPasswordPage from 'app/pages/ForgotPasswordPage';
import ResetPasswordPage from 'app/pages/ResetPasswordPage';
import SignUpPage from 'app/pages/SignUpPage';
import {
  FORGOT_PASSWORD,
  LOGIN,
  OTP,
  RESET_PASSWORD,
  ROOT,
  SIGNUP,
  TEAM_MEMBER,
  CUSTOMER,
  TRAVELER,
  CREATE_PASSWORD,
  TRIP,
  FEEDBACK,
  PROMOTION,
  REQUEST,
  REPORTS,
  FINANCIAL,
  PROFILE,
  DOCUMENT_EXPIRATION_ALERT_UNSUBSCRIBE,
  SEARCH,
  BANNER_CONFIG,
  NOTIFICATION,
} from 'configs/routeNames';
import LandingPage from 'app/pages/LandingPage';
import PageNotFound from 'app/pages/PageNotFound';
import Pages from './Pages';
import Login from 'app/modules/Auth/Login';
import Otp from 'app/pages/Otp';
import TeamMemberPage from 'app/pages/TeamMember';
import TravelerPage from 'app/pages/Traveler';
import FeedbackPage from 'app/pages/Feedback';
import CustomerPage from 'app/pages/Customer';
import TripPage from 'app/pages/Trip';
import Profile from 'app/modules/Profile';
// [IMPORT PAGES] < Needed for CRUD Generator
import { useRouteCleanup } from 'utils/useRouteCleanup';
import CreatePasswordPage from 'app/pages/CreatePasswordPage';
import UnderDevelop from 'app/molecules/UnderDevelopment';
import Financial from 'app/pages/Financial';
import PublicPages from './PublicPages';
import Reports from 'app/pages/Reports';
import ResultsPage from 'app/pages/ResultsPage';

import DocumentUnsubscribeAlerts from 'app/modules/Alerts/DocumentUnsubscribeAlerts';
import Banners from 'app/modules/Banners';
import NotificationCenterPage from 'app/pages/NotificationCenterPage';
import { AuthorizedRoute } from 'app/atoms';
import { PERMISSIONS_SUBJECTS } from 'app/modules/Auth/constants';

export default function AppRoutes() {
  useRouteCleanup();
  return (
    <Routes>
      <Route path="/" Component={PublicPages}>
        <Route path={LOGIN} Component={Login} />
        <Route path={SIGNUP} Component={SignUpPage} />
        <Route path={FORGOT_PASSWORD} Component={ForgotPasswordPage} />
        <Route path={RESET_PASSWORD} Component={ResetPasswordPage} />
        <Route path={CREATE_PASSWORD} Component={CreatePasswordPage} />
        <Route path={OTP} Component={Otp} />
      </Route>

      <Route path={DOCUMENT_EXPIRATION_ALERT_UNSUBSCRIBE} Component={DocumentUnsubscribeAlerts} />

      <Route path={ROOT} Component={Pages}>
        <Route index Component={LandingPage} />

        <Route
          path={`${TEAM_MEMBER}/*`}
          element={
            <AuthorizedRoute
              checkSubject={true}
              subject={PERMISSIONS_SUBJECTS.TRAVEL_AGENTS}
              Component={TeamMemberPage}
              redirect={ROOT}
            />
          }
        />

        <Route
          path={`${TRAVELER}/*`}
          element={
            <AuthorizedRoute
              checkSubject
              subject={PERMISSIONS_SUBJECTS.TRAVELERS}
              Component={TravelerPage}
              redirect={ROOT}
            />
          }
        />

        <Route path={`${FEEDBACK}/*`} Component={FeedbackPage} />

        <Route
          path={`${CUSTOMER}/*`}
          element={
            <AuthorizedRoute
              checkSubject
              subject={PERMISSIONS_SUBJECTS.CUSTOMERS}
              Component={CustomerPage}
              redirect={ROOT}
            />
          }
        />

        <Route path={`${TRIP}/*`} Component={TripPage} />

        <Route path={`${FINANCIAL}/*`} Component={Financial} />

        <Route
          path={`${REPORTS}/*`}
          element={
            <AuthorizedRoute
              checkSubject={true}
              subject={PERMISSIONS_SUBJECTS.REPORTS}
              Component={Reports}
              redirect={ROOT}
            />
          }
        />

        <Route path={`${BANNER_CONFIG}/*`} Component={Banners} />

        <Route path={`${PROFILE}/*`} Component={Profile} />
        <Route path={`${NOTIFICATION}/*`} Component={NotificationCenterPage} />
        <Route path={`${SEARCH}/*`} Component={ResultsPage} />
        <Route path={`${PROMOTION}/*`} Component={UnderDevelop} />
        <Route path={`${REQUEST}/*`} Component={UnderDevelop} />
        {/* Don't remove this comment. It will be used in CRUD generator. */}
        <Route path="*" Component={PageNotFound} />
      </Route>
    </Routes>
  );
}
